<template>
  <div class="language-switcher">
    <span class="lang-label" :class="{ active: !isThai() }">🇺🇸 EN</span>

    <button
      @click="toggleLanguage"
      class="toggle-switch"
      :class="{ thai: isThai() }"
    >
      <div class="toggle-slider"></div>
    </button>

    <span class="lang-label" :class="{ active: isThai() }">ไทย 🇹🇭</span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables/useI18n'

const { toggleLanguage, isThai } = useI18n()
</script>

<style scoped>
.language-switcher {
  @apply flex items-center gap-3;
}

.lang-label {
  @apply text-sm font-medium text-gray-500 transition-colors duration-200;
}

.lang-label.active {
  @apply text-gray-900;
}

.toggle-switch {
  @apply relative w-14 h-8 bg-gray-200 rounded-full transition-colors duration-300 cursor-pointer;
}

.toggle-switch:hover {
  @apply bg-gray-300;
}

.toggle-switch.thai {
  @apply bg-indigo-600;
}

.toggle-switch.thai:hover {
  @apply bg-indigo-700;
}

.toggle-slider {
  @apply absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow-md transition-transform duration-300;
}

.toggle-switch.thai .toggle-slider {
  @apply translate-x-6;
}
</style>
